/**
 * Ekrani izveštaja firme "više restorana" (računar): brojke i stanje učitavanja idu u zaglavlje ljuske. Ekran daje
 * `kpis`, `busy` (učitava se) i `hasRows` (ima šta da se prikaže). Smene iz zajedničke trake ljuska upisuje u store
 * (filters.selectedShifts), odakle ih čitaju stari tabovi, pa je prop `shifts` samo da ne završi kao atribut.
 */
export default {
  props: {
    shifts: { type: Array, default: () => [] },
  },
  watch: {
    kpis: {
      handler(kpis) {
        this.$emit("kpis", this.hasRows ? kpis : []);
      },
      immediate: true,
    },
    hasRows() {
      this.$emit("kpis", this.hasRows ? this.kpis : []);
    },
    busy: {
      handler(busy) {
        this.$emit("loading", Boolean(busy));
      },
      immediate: true,
    },
  },
};
